export default __webpack_public_path__ + "static/media/image-xx99-mark-one-headphones.95d04bf1.jpg";